import React from "react"
import PropTypes from "prop-types"
import { getPatientAge, getViewPatientData } from "../../../lib"
import "./PatientSidebar.less"
import Grid from "../../Fhir/Grid";

export default class AllergySidebar extends React.Component {
    static propTypes = {
        allergy: PropTypes.object.isRequired,
        isOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        settings: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            patientData: [],
            loading: false,
            error: null
        };
    }

    componentDidMount() {
        this.fetchPatientData();
    }

    componentDidUpdate(prevProps) {
        // Refetch data if allergy prop changes
        if (this.props.allergy !== prevProps.allergy) {
            this.fetchPatientData();
        }
    }

    fetchPatientData = async () => {
        if (!this.props.allergy) return;

        this.setState({ loading: true, error: null });

        try {
            const { server } = this.props.settings;
            let apiUrl = `${server.url}/patient-list-allergy-code?code=${this.props.allergy?.allergyCode}`;

            const data = await getViewPatientData({
                url: apiUrl,
                server: this.props.settings.server
            });

            console.log("Fetched patient data for allergy:", data);
            this.setState({
                patientData: Array.isArray(data) ? data : (data?.records || []),
                loading: false
            });
        } catch (error) {
            console.error("Error fetching patient data:", error);
            this.setState({
                error: error.message,
                loading: false,
                patientData: []
            });
        }
    }

    renderAllergyDetails() {
        const { allergy } = this.props;
        const { loading, error, patientData } = this.state;

        return (
            <div>
                <div className="patient-basic-info">
                    <h3 className="text-primary">
                        {allergy.allergyCode || "Unknown Code"} - {allergy.allergyDescription || "No Description"}
                    </h3>
                    <div className="patient-details-grid">
                        <div className="detail-item">
                            <span className="label">Code:</span>
                            <span className="value">{allergy.allergyCode || "Unknown"}</span>
                        </div>
                        <div className="detail-item">
                            <span className="label">Code System:</span>
                            <span className="value">{allergy.allergyCodeSystem || "Unknown"}</span>
                        </div>
                        <div className="detail-item">
                            <span className="label">Description:</span>
                            <span className="value">{allergy.allergyDescription || "Unknown"}</span>
                        </div>
                    </div>
                </div>
                <br />
                <div className="tab-content-wrapper">

                    {loading && (
                        <div className="text-center">
                            <i className="fa fa-spinner fa-spin" /> Loading patients...
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger">
                            Error loading patients: {error}
                        </div>
                    )}

                    {!loading && !error && patientData.length === 0 && (
                        <p className="text-muted">No patients found with this allergy.</p>
                    )}

                    {!loading && !error && patientData.length > 0 && (
                        <Grid
                            rows={patientData}
                            title="Patients with this Allergy"
                            cols={[
                                {
                                    label: "Patient Name",
                                    render: (row) => `${row.patientFirstName || ''} ${row.patientLastName || ''}`.trim() || 'Unknown'
                                },
                                {
                                    label: "MRN",
                                    path: "patientMRN"
                                },
                                {
                                    label: "DOB",
                                    path: "patientDOB"
                                },
                                {
                                    label: "Age",
                                    render: (row) => getPatientAge(row.patientDOB) || 'Unknown'
                                }
                            ]}
                        />
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { isOpen, onClose } = this.props;

        if (!isOpen) {
            console.log("AllergySidebar not rendering because isOpen is false");
            return null;
        }

        return (
            <div className="patient-sidebar-overlay" onClick={onClose}>
                <div className="patient-sidebar" onClick={e => e.stopPropagation()}>
                    {/* Header */}
                    <div className="sidebar-header">
                        <h4>Allergy Details</h4>
                        <button className="close-btn" onClick={onClose}>
                            <i className="fa fa-times" />
                        </button>
                    </div>

                    {/* Content */}
                    <div className="sidebar-patient-details">
                        {this.renderAllergyDetails()}
                    </div>
                </div>
            </div>
        );
    }
}